<a class="card is-frameless is-revealable team-filter__item" :class="{'is-active': isActive}" :href="person.link" @click="toggleDetail">
	<spinner :modelValue="isLoading" />
	<img class="card-background" :src="`${person.imageUrl}?width=350&height=350`" :alt="`${person.firstname} ${person.lastname}`" />
	<div class="card-header">
		<h3 class="title is-5 has-text-weight-normal mb-1">{{person.firstname}} {{person.lastname}}</h3>
	</div>
	<div class="is-revealable__outer">
		<div class="is-revealable__inner">
			<div class="card-content">
				<ul class="team-filter__item-functions">
					<li v-for="func in visibleFunctions">{{func.description}}</li>
				</ul>
			</div>
		</div>
	</div>
</a>
<person-detail class="team-filter__item-detail" v-if="isActive" :person="personDetail" @close="toggleDetail" />
